import type * as React from "react";
import { cn } from "@/lib/utils";

function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      data-slot="kbd"
      className={cn("inline-block min-w-5 rounded border bg-muted px-1 text-center font-mono text-[11px] leading-[18px] text-muted-foreground", className)}
      {...props}
    />
  );
}

export { Kbd };
